import { Button } from 'components/Button/Button'
import { translate } from 'i18n/i18n'

export const LegacyRedirectBannerMessage = () => {
  return (
    <>
      {translate.phrases.banyanApp(
        "Welcome to Semios Hub, the next generation of our app! You've been automatically redirected as Semios Live is now discontinued. Need help?",
      )}
      <a href="https://semios.com/support/" target="_blank" rel="noopener noreferrer">
        <Button variant="link">{translate.phrases.banyanApp('Contact Support')}</Button>
      </a>
    </>
  )
}
